import { Button, Group, Select, Stack, Text } from '@mantine/core';
import { HiOutlineFilter } from 'react-icons/hi';
import ModalPopupComponent from 'components/ModalPopup';
import React, { useEffect, useState } from 'react';
import { CourseParams } from './TableCourses';
import { courseService } from 'services/lcms/course.service';
import { useQuery } from '@tanstack/react-query';

interface ModalFilterCourseProps {
  opened: boolean;
  defaultValue?: CourseParams;
  onClose: () => void;
  onFilter: (_data: CourseParams) => void;
}

const defaultParams = { pageNumber: 1, pageSize: 10000 };

const ModalFilterCourse: React.FC<ModalFilterCourseProps> = ({
  defaultValue,
  onClose,
  onFilter,
  opened
}) => {
  const [value, setValue] = useState<[Date | null, Date | null]>([null, null]);
  const [selectedStatus, setSelectedStatus] = useState<string | null>('');
  const [selectedCourseCategory, setSelectedCourseCategory] = useState<string | null>('');
  const [selectedCompetencyCategory, setSelectedCompetencyCategory] = useState<string | null>('');

  const { data: dataCourseCategory, isPending: loadingCourseCategory } = useQuery({
    queryKey: ['courseServiceGetCourseCategories'],
    queryFn: () => courseService.getCourseCategories(defaultParams)
  });

  const { data: dataCompetencyCategories, isPending: loadingCompetencyCategories } = useQuery({
    queryKey: ['getCompetencyCategories'],
    queryFn: () => courseService.getCompetencyCategories(defaultParams)
  });

  useEffect(() => {
    if (defaultValue) {
      setValue([defaultValue.startDate, defaultValue.endDate]);
      setSelectedStatus(defaultValue.status);
    }
  }, [defaultValue]);

  const handleFilter = () => {
    onFilter({
      status: selectedStatus,
      startDate: value[0],
      endDate: value[1],
      courseCategory: selectedCourseCategory,
      competencyCategory: selectedCompetencyCategory
    });
  };

  const handleReset = () => {
    setValue([null, null]);
    setSelectedStatus(null);
    setSelectedCourseCategory(null);
    setSelectedCompetencyCategory(null);
    onFilter({
      status: null,
      startDate: null,
      endDate: null,
      courseCategory: null,
      competencyCategory: null
    });
  };

  return (
    <ModalPopupComponent
      title={
        <Group gap={4}>
          <HiOutlineFilter size={20} />{' '}
          <Text fw={700} fz={20}>
            Filter
          </Text>
        </Group>
      }
      opened={opened}
      close={onClose}
    >
      <Stack>
        <Select
          label='Status'
          placeholder='Select Status'
          data={['Draft', 'Completed']}
          onChange={(value) => setSelectedStatus(value || '')}
          value={selectedStatus}
        />
        <Select
          label='Course Category'
          placeholder={loadingCourseCategory ? 'Loading...' : 'Select Course Category'}
          data={
            dataCourseCategory?.data?.map((item: { id: number; name: string }) => ({
              value: item.id.toString() + '-' + item.name,
              label: item.name
            })) || []
          }
          searchable
          disabled={loadingCourseCategory}
          onChange={(value) => setSelectedCourseCategory(value || '')}
          value={selectedCourseCategory}
        />
        <Select
          label='Competency Category'
          placeholder={loadingCompetencyCategories ? 'Loading...' : 'Select competency category'}
          data={
            dataCompetencyCategories?.data?.map(
              (item: { competencyCategoryDesc: string }) => item.competencyCategoryDesc
            ) || []
          }
          searchable
          disabled={loadingCompetencyCategories}
          onChange={(value) => setSelectedCompetencyCategory(value || '')}
          value={selectedCompetencyCategory}
        />
        <Group justify='space-between' mt={20}>
          <Button onClick={onClose} variant='outline'>
            Close
          </Button>
          <Group>
            <Button variant='transparent' onClick={handleReset}>
              Reset
            </Button>
            <Button onClick={handleFilter}>Filter</Button>
          </Group>
        </Group>
      </Stack>
    </ModalPopupComponent>
  );
};

export default ModalFilterCourse;
